import { put, takeLatest, select } from 'redux-saga/effects'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'

// action types

export const SELECT_ALL = 'rp/bulkPayment/SELECT_ALL'
export const SELECT_ONE = 'rp/bulkPayment/SELECT_ONE'
export const UPDATE_PAYMENT = 'rp/bulkPayment/UPDATE_PAYMENT'
export const RESET_PAYMENT = 'rp/bulkPayment/RESET_PAYMENT'
export const SET_PAYMENT = 'rp/bulkPayment/SET_PAYMENT'
export const SET_SELECTED_METHOD_CONV_FEE = 'rp/bulkPayment/SET_SELECTED_METHOD_CONV_FEE'
export const SYNC_BULKPAYMENT = 'rp/bulkPayment/SYNC_BULKPAYMENT'
export const SYNC_POSITIVE_BALANCE = 'rp/bulkPayment/SYNC_POSITIVE_BALANCE'
export const SET_PAYMENT_AMOUNT_TYPE = 'rp/bulkPayment/SET_PAYMENT_AMOUNT_TYPE'
export const SET_CUSTOM_BULK_PAYMENTS =
  'rp/bulkPayment/SET_CUSTOM_BULK_PAYMENTS'
export const SET_PAYMENT_METHOD = 'rp/bulkPayment/SET_PAYMENT_METHOD'
export const SET_CUSTOM_AMOUNT = 'rp/bulkPayment/SET_CUSTOM_AMOUNT'
export const SET_CURRENT_PAYMENT_PAGE =
  'rp/bulkPayment/SET_CURRENT_PAYMENT_PAGE'
export const SET_SHOW_VALIDATE_POPUP = 'rp/bulkPayment/SET_SHOW_VALIDATE_POPUP'
export const SET_SHOW_PROMISE_TO_PAY = 'rp/bulkPayment/SET_SHOW_PROMISE_TO_PAY'
const CLEAR_BULK_PAYMENT = 'rp/bulkPayment/CLEAR_BULK_PAYMENT'

// action creators

export const selectAll = payload => ({
  type: SELECT_ALL,
  payload,
})

export const selectOne = payload => ({
  type: SELECT_ONE,
  payload,
})

export const updateBulkPaymentAmounts = payload => ({
  type: UPDATE_PAYMENT,
  payload,
})

export const resetBulkPaymentAmounts = payload => ({
  type: RESET_PAYMENT,
  payload,
})

export const setBulkPaymentAmounts = payload => ({
  type: SET_PAYMENT,
  payload,
})

export const setSelectedPaymentMethodConvFee = payload => ({
  type: SET_SELECTED_METHOD_CONV_FEE,
  payload,
})

export const syncBulkPayment = (payload, callback) => ({
  type: SYNC_BULKPAYMENT,
  payload,
  callback,
})

export const syncPositiveBalance = payload => ({
  type: SYNC_POSITIVE_BALANCE,
  payload,
})

export const setPaymentAmountType = payload => ({
  type: SET_PAYMENT_AMOUNT_TYPE,
  payload,
})

export const setCustomBulkPayments = payload => ({
  type: SET_CUSTOM_BULK_PAYMENTS,
  payload,
})

export const setPaymentMethod = payload => ({
  type: SET_PAYMENT_METHOD,
  payload,
})

export const setCustomPaymentAmount = payload => ({
  type: SET_CUSTOM_AMOUNT,
  payload,
})

export const setCurrentPaymentPage = payload => ({
  type: SET_CURRENT_PAYMENT_PAGE,
  payload,
})

export const setShowValidatePayment = payload => ({
  type: SET_SHOW_VALIDATE_POPUP,
  payload,
})

export const setShowPromiseToPayCheckbox = payload => ({
  type: SET_SHOW_PROMISE_TO_PAY,
  payload,
})

export const clearBulkPaymentDetails = payload => ({
  type: CLEAR_BULK_PAYMENT,
  payload,
})

const PAYMENT_PAGES = {
  AMOUNT: 1,
  METHOD: 2,
  SUMMARY: 3,
}

let intialState = {
  paymentAmountType: 'full',
  totalPaymentAmount: 0,
  bulkPaymentDetails: null,
  customBulkPayments: [],
  paymentMethod: {},
  customPaymentAmount: 0,
  isBulkPaymentDataLoaded: false,
  currentPaymentPage: PAYMENT_PAGES.AMOUNT,
  showValidatePayment: false,
  showPromiseToPayCheckbox: false,
}

// reducer
export default (state = intialState, { payload, type }) => {
  const { bulkPaymentDetails, paymentMethod } = state || {}
  switch (type) {
    case SELECT_ALL:
      return {
        ...state,
        bulkPaymentDetails: Object.values(bulkPaymentDetails)?.reduce(
          (obj, bulkPay) => ({
            ...obj,
            [bulkPay?.id]: {
              ...bulkPay,
              is_checked: payload.value,
              payment: !payload.value ? 0 : bulkPay.balance_Due,
            },
          }),
          {},
        ),
      }
    case SELECT_ONE:
      return {
        ...state,
        bulkPaymentDetails: {
          ...bulkPaymentDetails,
          [payload.id]: {
            ...bulkPaymentDetails[payload.id],
            is_checked: payload.value,
            payment: !payload.value
              ? 0
              : bulkPaymentDetails[payload.id].payment ||
                bulkPaymentDetails[payload.id].balance_Due,
          },
        },
      }
    case UPDATE_PAYMENT:
      return {
        ...state,
        bulkPaymentDetails: {
          ...bulkPaymentDetails,
          [payload.id]: {
            ...bulkPaymentDetails[payload.id],
            payment: payload.value,
          },
        },
      }
    case RESET_PAYMENT:
      return payload.amountType === 'full'
        ? { ...intialState, paymentMethod: state.paymentMethod }
        : {
            ...state,
            bulkPaymentDetails,
            paymentAmountType: payload.amountType,
          }
    case SET_PAYMENT:
      return {
        ...state,
        ...payload,
      }
    case SYNC_POSITIVE_BALANCE:
      return {
        ...state,
        totalPaymentAmount: payload,
      }
    case SET_PAYMENT_AMOUNT_TYPE:
      return {
        ...state,
        paymentAmountType: payload,
      }
    case SET_CUSTOM_BULK_PAYMENTS:
      return {
        ...state,
        customBulkPayments: payload,
      }
    case SET_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: { ...paymentMethod, ...payload },
      }
    case SET_CUSTOM_AMOUNT:
      return {
        ...state,
        customPaymentAmount: payload,
      }
    case SET_CURRENT_PAYMENT_PAGE:
      return {
        ...state,
        currentPaymentPage: payload,
      }
    case SET_SHOW_VALIDATE_POPUP:
      return {
        ...state,
        showValidatePayment: payload,
      }
    case SET_SHOW_PROMISE_TO_PAY:
      return {
        ...state,
        showPromiseToPayCheckbox: payload,
      }
    case SET_SELECTED_METHOD_CONV_FEE:
      return {
        ...state,
        selectedMethodConvFee: payload,
      }
    case CLEAR_BULK_PAYMENT: {
      const { bulkPaymentDetails, ...rest } = state

      return { ...rest }
    }

    default:
      return state
  }
}

// Selector
export function initialBulkPaymentSelector(
  balanceDue,
  properties,
  leases,
  propertyId,
  leasePermissions,
) {
  if (!leasePermissions) return null
  //Step1: Get the current selected Property leases which are active
  let activePropertyLeases = []
  if (Object.values(properties)?.length > 1) {
    const currentPropertyLeaseIds =
      (properties[propertyId] && properties[propertyId]?.leases) || []
    activePropertyLeases = Object.values(leases).filter(
      lease =>
        currentPropertyLeaseIds?.some(leaseId => lease?.lease_id === leaseId) &&
        ['Current', 'Notice', 'Future'].includes(lease?.lease_status) &&
        !lease?.is_lease_under_eviction,
    )
  } else {
    activePropertyLeases = Object.values(leases).filter(
      lease =>
        ['Current', 'Notice', 'Future'].includes(lease?.lease_status) &&
        !lease?.is_lease_under_eviction,
    )
  }

  //Step 2: Get the unavailable payments i.e one_time_payment = false
  const unavailablePayments = Object.values(leasePermissions).reduce(
    (paymentPermission, { lease_id, resident_pay }) => {
      return {
        ...paymentPermission,
        [lease_id]: { status: resident_pay?.one_time_payment?.add },
      }
    },
    [],
  )
  //Step 3: Add the allows property in bulkPaymentDetails as per unavailablePayments

  if (balanceDue?.total_balance !== undefined) {
    const bulkPaymentDetails = Object.values(activePropertyLeases).reduce(
      (obj, { lease_id, unit_number }) => {
        const defaultBalance =
          balanceDue?.lease_balance && balanceDue?.lease_balance[lease_id]
            ? balanceDue?.lease_balance[lease_id]
            : 0
        return {
          ...obj,
          [lease_id]: {
            id: lease_id,
            isValidUnitNumber: unit_number && unit_number != '' ? true : false,
            unit: unit_number || `#${lease_id}`,
            balance_Due: defaultBalance,
            payment: defaultBalance,
            is_checked: balanceDue?.lease_balance?.[lease_id] > 0,
            allowed:
              (unavailablePayments[lease_id] &&
                unavailablePayments[lease_id].status) ||
              false,
          },
        }
      },
      [],
    )
    intialState.bulkPaymentDetails = bulkPaymentDetails
    return bulkPaymentDetails
  } else {
    intialState.bulkPaymentDetails = null
    return null
  }
}

export function getUnavailableBulkPaymentSelector(bulkPayment = {}) {
  return (
    bulkPayment &&
    Object.values(bulkPayment)?.filter(payment => !payment?.allowed)
  )
}

// sagas

function* updateBulkPayment({ payload, callback }) {
  try {
    yield put({ type: payload?.type, payload })
    const {
      bulkPayment: { bulkPaymentDetails = {} },
    } = yield select()
    typeof callback === 'function' &&
      bulkPaymentDetails &&
      callback(bulkPaymentDetails)
  } catch (error) {
    console.log('FUNCTION updateBulkPayment ', error)
  }
}

function* watchUpdateBulkPayment() {
  yield takeLatest(
    SYNC_BULKPAYMENT,
    createRequestSaga(updateBulkPayment, {
      key: 'bulk_payments',
    }),
  )
}

export const sagas = [watchUpdateBulkPayment]
